import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, useCallback, FormEventHandler } from 'react';
import { withBufferedValue } from '../../decorators/withBufferedValue/withBufferedValue';
import { prepareProps } from '../../utils/propUtils';
import { InputLayout, InputLayoutProps } from '../InputLayout/InputLayout';
import sharedStyles from '../sharedStyles.module.css';
export enum TextInputType {
  Text = 'text',
  Password = 'password',
  Email = 'email',
}
export type TextInputProps = Omit<InputLayoutProps, 'children' | 'onInput' | 'onChange' | 'onInputCapture' | 'onChangeCapture'> & {
  value: string;
  type?: TextInputType;
  onInput: (value: string) => void;
};
export const TextInput: FunctionComponent<TextInputProps> = React.memo(props => {
  const $ = _c(16);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onInput;
  let remainingProps;
  let t1;
  let value;
  if ($[2] !== t0) {
    ({
      value,
      type: t1,
      onInput,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onInput;
    $[4] = remainingProps;
    $[5] = t1;
    $[6] = value;
  } else {
    onInput = $[3];
    remainingProps = $[4];
    t1 = $[5];
    value = $[6];
  }
  const type = t1 === undefined ? TextInputType.Text : t1;
  let t2;
  if ($[7] !== onInput) {
    t2 = event => {
      onInput(event.currentTarget.value);
    };
    $[7] = onInput;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleInput = t2;
  let t3;
  if ($[9] !== handleInput || $[10] !== type || $[11] !== value) {
    t3 = () => <input type={type} className={sharedStyles.inputBaseStyle} value={value} onInput={handleInput} data-testid="TextInput.input" />;
    $[9] = handleInput;
    $[10] = type;
    $[11] = value;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== remainingProps || $[14] !== t3) {
    t4 = <InputLayout {...remainingProps}>{t3}</InputLayout>;
    $[13] = remainingProps;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
});
export const BufferedTextInput = withBufferedValue(TextInput);